export const SET_USERS_CREDENTIALS = 'user/SET_USER_CREDENTIALS';
export const UPDATE_USERS_CREDENTIALS = 'user/UPDATE_USERS_CREDENTIALS';
export const SET_IS_LOGGED_IN = 'user/SET_IS_LOGGED_IN';
export const SET_ACCESS_TOKEN = 'user/SET_ACCESS_TOKEN';
export const REFRESH_ACCESS_TOKEN = 'user/REFRESH_ACCESS_TOKEN';
export const CHANGE_PASSWORD = 'user/CHANGE_PASSWORD';
